/**
 * Panel Mappings API Endpoints
 * Nested under /instruments/{instrumentId}/panels/{panelId}/mappings
 */
export const PANEL_MAPPINGS_ENDPOINTS = {
  /**
   * Get all mappings for a panel.
   * @method GET
   * @endpoint /instruments/{instrumentId}/panels/{panelId}/mappings
   */
  PANEL_MAPPINGS: (instrumentId: number, panelId: number) => `/instruments/${instrumentId}/panels/${panelId}/mappings`,

  /**
   * Create a new panel mapping.
   * @method POST
   * @endpoint /instruments/{instrumentId}/panels/{panelId}/mappings
   */
  CREATE_PANEL_MAPPING: (instrumentId: number, panelId: number) =>
    `/instruments/${instrumentId}/panels/${panelId}/mappings`,

  /**
   * Update or delete a panel mapping by mappingKey.
   * @endpoint /instruments/{instrumentId}/panels/{panelId}/mappings/{mappingKey}
   */
  PANEL_MAPPING_BY_KEY: (instrumentId: number, panelId: number, mappingKey: string) =>
    `/instruments/${instrumentId}/panels/${panelId}/mappings/${encodeURIComponent(mappingKey)}`,
} as const;
